export const isDateValue = (date: any) => {
  return date instanceof Date && !isNaN(date.getDate());
};

// check +18
export const isValidDate = (date: Date, minAge: number) => {
  const today = new Date();
  let age = today.getFullYear() - date.getFullYear();
  const months = today.getMonth() - date.getMonth();
  if (months < 0 || (months === 0 && today.getDate() < date.getDate())) {
    age--;
  }
  return age >= minAge;
};

export const isValidDatePregnancy = (date: Date) => {
  const today = new Date();
  const compareDate = date.getDate() >= today.getDate();
  const compareMonth = date.getMonth() == today.getMonth();
  const compareYear = date.getFullYear() >= today.getFullYear();
  const pregnancyMonth = date.getMonth() + 1 <= today.getMonth() + 10;
  const bornDateFuture = date.getMonth() <= today.getMonth() + 9 - 12;

  if (compareYear) {
    if (date.getFullYear() === today.getFullYear()) {
      if (pregnancyMonth) {
        if (compareMonth) {
          return compareDate;
        } else {
          return true;
        }
      }
    } else {
      return bornDateFuture;
    }
  }
  return false;
};

export const isValidDateBorn = (date: Date) => {
  const today = new Date();
  return date < today;
};

export const generateMaxDatePregnancy = (type: string) => {

  const today = new Date();
  let maxDate = null;

  switch (type) {
    case 'pregnancyDate':
      if(today.getMonth() + 9 > 11) {
        maxDate = `${today.getDate()}/${today.getMonth() + 10 - 12}/${today.getFullYear()+1}`
      } else {
        maxDate = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`
      }
      break;
    case 'pregnancyDateBorn':
      maxDate = `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()}`
      break;
  }

  return maxDate;
};

export const getMaxMonthDay = (year: number, month: number) => {
  const date = new Date(year, month, 0);
  const maxDay = date.getDate();
  return maxDay;
};

export const constructDate = (year: number, month: number, day: number) => {
  const validParameters = Boolean(
    (day || day === 0) && (month || month === 0) && year,
  );
  if (!validParameters) return false;

  // Se añade hora = 1 para que el dia sea el de nuestra zona horaria UTC+1
  const selectedDate = new Date(Date.UTC(year, month - 1, day, 1, 0, 0));

  return selectedDate;
};

export const getStringInputValue = (value: string | undefined) => {
  if (!value) return undefined;

  const inputLength = value.toString().length;
  if (!+value || inputLength === 2) return `${value}`;

  return `0${value}`;
};

export const handleKeyDown = (
  ev: Event & { target: Element; which: number },
) => {
  const { target, which } = ev;
  const index = parseFloat(target.getAttribute('data-index'));
  const nextItem: any = document.querySelector(`[data-index="${index + 1}"]`);
  const prevItem: any = document.querySelector(`[data-index="${index - 1}"]`);
  switch (which) {
    case 8:
      if (
        (target.getAttribute('data-index') === '5' ||
          target.getAttribute('data-index') === '6') &&
        target.getAttribute('value') === ''
      ) {
        prevItem.focus();
      }
      break;
    case 13:
      ev.preventDefault();
      if (!nextItem) return;
      nextItem.focus();
      break;
    case (which >= 48 && which <= 57) ||
    (which >= 96 && which <= 105) ||
    which === 229
      ? which
      : -1:
      if (
        (target.getAttribute('data-index') === '4' ||
          target.getAttribute('data-index') === '5') &&
        window.getSelection().type !== 'Range' &&
        target.getAttribute('value').length === 2
      ) {
        nextItem.focus();
        nextItem.select();
      }
      break;
  }
};

export const handleKeyDownPregnancy = (
  ev: Event & { target: Element; which: number },
) => {
  const { target, which } = ev;
  const index = parseFloat(target.getAttribute('data-index'));
  const nextItem: any = document.querySelector(`[data-index="${index + 1}"]`);
  const prevItem: any = document.querySelector(`[data-index="${index - 1}"]`);
  switch (which) {
    case 8:
      if (
        (target.getAttribute('data-index') === '8' ||
          target.getAttribute('data-index') === '9') &&
        target.getAttribute('value') === ''
      ) {
        prevItem.focus();
      }
      break;
    case 13:
      ev.preventDefault();
      if (!nextItem) return;
      nextItem.focus();
      break;
    case (which >= 48 && which <= 57) ||
    (which >= 96 && which <= 105) ||
    which === 229
      ? which
      : -1:
      if (
        (target.getAttribute('data-index') === '7' ||
          target.getAttribute('data-index') === '8') &&
        window.getSelection().type !== 'Range' &&
        target.getAttribute('value').length === 2
      ) {
        nextItem.focus();
        nextItem.select();
      }
      break;
  }
};
